export default {
  ZH_HK: {
    FwkContent: "框架內容",
    WorkshopTitle: "研討會名稱",
    RoleName: "角色名稱",
    RecActivities: "推薦活動",
    Activities: "活動",
    Article: "文章內容",
    Topic: "題目",
    Format: "活動形式",
    Analysis: "分析判斷",
    Summary: "課堂總結",
    End: "結束",
    GenTalk: "生成Talk",
    DiscussionContent: "討論內容",
    FinalLessonSummary: "最後課堂總結",
    Enter: "請輸入",
    time: "時間",
    changeCover: "更換封面",
    save: "保存",
    close: "關閉",
    isSave: "是否保存内容?",
    RegenerateDiscussionContent: "重新生成討論內容",
    RegenerateTheQuestion: "重新生成題目",
    RegenerateTheOptions: "重新生成選項"
  },
  zh_cn: {
    FwkContent: "框架内容",
    WorkshopTitle: "研讨会名称",
    RoleName: "角色名称",
    RecActivities: "推荐活动",
    Activities: "活动",
    Article: "文章内容",
    Topic: "题目",
    Format: "活动形式",
    Analysis: "分析判断",
    Summary: "课堂总结",
    End: "结束",
    GenTalk: "生成Talk",
    DiscussionContent: "讨论内容",
    FinalLessonSummary: "最后课堂总结",
    Enter: "请输入",
    time: "时间",
    changeCover: "更换封面",
    save: "保存",
    close: "关闭",
    isSave: "是否保存内容?",
    RegenerateDiscussionContent: "重新生成讨论内容",
    RegenerateTheQuestion: "重新生成题目",
    RegenerateTheOptions: "重新生成选项"
  },
  EN: {
    FwkContent: "Framework Contents",
    WorkshopTitle: "Workshop Title",
    RoleName: "Role Name",
    RecActivities: "Recommended Activities",
    Article: "Article Content",
    Topic: "Question",
    Format: "Format",
    Analysis: "Analyze and judge",
    Summary: "Summary",
    Activities: "Activity",
    End: "End",
    GenTalk: "Generate Talk",
    DiscussionContent: "Theme-Based Discussion",
    FinalLessonSummary: "Final Lesson Summary",
    Enter: "please input",
    time: "Time",
    changeCover: "Change Cover",
    save: "Save",
    close: "Close",
    isSave: "Save the content?",
    RegenerateDiscussionContent: "Regenerate Theme-Based Discussion",
    RegenerateTheQuestion: "Regenerate The Question",
    RegenerateTheOptions: "Regenerate The Options"
  },
  es: {
    FwkContent: "Contenidos del Marco",
    WorkshopTitle: "Título del Taller",
    RoleName: "Nombre del Rol",
    RecActivities: "Actividades recomendadas",
    Article: "Contenido del artículo",
    Topic: "Pregunta",
    Format: "Formato",
    Analysis: "Análisis y juicio",
    Summary: "Resumen",
    End: "Fin",
    GenTalk: "Generar Talk",
    Activities: "Actividad",
    DiscussionContent: "Contenido de Discusión",
    FinalLessonSummary: "Resumen Final de la Clase",
    Enter: "Por favor ingrese",
    time: "Tiempo",
    changeCover: "Cambiar Portada",
    save: "Guardar",
    close: "Cerrar",
    isSave: "¿Guardar el contenido?",
    RegenerateDiscussionContent: "Regenerar Contenido de Discusión",
    RegenerateTheQuestion: "Regenerar la pregunta",
    RegenerateTheOptions: "Regenerar Las Opciones"
  }
};
